import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import "./scss/index.scss";
export var StatusProgress = function StatusProgress() {
  var intl = useIntl();
  return React.createElement("div", {
    className: "progress-bar"
  }, React.createElement("ul", {
    className: "progress-bar--container"
  }, React.createElement("li", {
    className: "item active"
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Scheduled",
    "id": "components.StatusProgress.StatusProgress.2020280089"
  }, "id", "components.StatusProgress.StatusProgress.2020280089"))), React.createElement("div", null)), React.createElement("li", {
    className: "item active"
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "In progress",
    "id": "components.StatusProgress.StatusProgress.2737619734"
  }, "id", "components.StatusProgress.StatusProgress.2737619734"))), React.createElement("div", null)), React.createElement("li", {
    className: "item"
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Produced",
    "id": "components.StatusProgress.StatusProgress.2291281990"
  }, "id", "components.StatusProgress.StatusProgress.2291281990"))), React.createElement("div", null)), React.createElement("li", {
    className: "item"
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Shipped",
    "id": "components.StatusProgress.StatusProgress.3888449579"
  }, "id", "components.StatusProgress.StatusProgress.3888449579"))), React.createElement("div", null))));
};